import produce from "immer"
import { ASC, DESC, PRIVATE, PUBLISHED } from "const"
import { CcLibrarySet } from "server/models"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

export const initCcLibrarySet: CcLibrarySet = {
    id: null,
    originalSetId: null,
    accountId: null,
    projectId: null,
    publicId: "",
    name: "",
    description: "",
    logoId: null,
    logo: null,
    ownerAccount: null,
    creator: null,
    locked: false,
    access: PRIVATE,
    status: PUBLISHED,
    cost: 0,
    formal: false,
    default: false,
}

const initCcLibrarySetState: types.CcLibrarySetState = {
    baseRoute: null,

    setList: {},
    setIds: [],
    setView: initCcLibrarySet,
    setEdit: initCcLibrarySet,

    sortColumn: "createdAt",
    sortOrder: DESC,
    filters: {
        imported: false,
        created: false,
        status: null,
        search: null,
    },

    reloadList: true,
    reloadView: true,
    reloadEdit: true,

    importFromLibrary: {
        setList: {},
        setIds: [],
        sortColumn: "name",
        sortOrder: ASC,
        filters: {
            search: null,
        },
    },

    importFromAccount: {
        setList: {},
        setIds: [],
        sortColumn: "name",
        sortOrder: ASC,
        filters: {
            search: null,
        },
    },

    importSetId: null,
    reloadImported: true,
}

const ccLibrarySetReducer = produce((
    draft: types.CcLibrarySetState = initCcLibrarySetState,
    action: ActionTypes = null,
): types.CcLibrarySetState => {
    switch (action.type) {
        case types.CC_LIBRARY_SET_BASE_ROUTE:
            draft.baseRoute = action.baseRoute
            return draft

        case types.CC_LIBRARY_SET_LIST:
            draft.setList = action.setList
            return draft

        case types.CC_LIBRARY_SET_IDS:
            draft.setIds = action.setIds
            return draft

        case types.CC_LIBRARY_SET_VIEW:
            draft.setView = action.set
            return draft

        case types.CC_LIBRARY_SET_EDIT:
            draft.setEdit = action.set
            return draft

        case types.CC_LIBRARY_SET_SORT:
            draft.sortColumn = action.sortColumn
            draft.sortOrder = action.sortOrder
            return draft

        case types.CC_LIBRARY_SET_FILTERS:
            draft.filters = action.filters
            return draft

        case types.CC_LIBRARY_SET_RELOAD_LIST:
            draft.reloadList = action.value
            return draft

        case types.CC_LIBRARY_SET_RELOAD_VIEW:
            draft.reloadView = action.value
            return draft

        case types.CC_LIBRARY_SET_RELOAD_EDIT:
            draft.reloadEdit = action.value
            return draft


        // import from library
        case types.CC_LIBRARY_SET_IMPORT_FROM_LIBRARY_LIST:
            draft.importFromLibrary.setList = action.setList
            return draft

        case types.CC_LIBRARY_SET_IMPORT_FROM_LIBRARY_IDS:
            draft.importFromLibrary.setIds = action.setIds
            return draft

        case types.CC_LIBRARY_SET_IMPORT_FROM_LIBRARY_SORT:
            draft.importFromLibrary.sortColumn = action.sortColumn
            draft.importFromLibrary.sortOrder = action.sortOrder
            return draft

        case types.CC_LIBRARY_SET_IMPORT_FROM_LIBRARY_FILTERS:
            draft.importFromLibrary.filters = action.filters
            return draft


        // import from account
        case types.CC_LIBRARY_SET_IMPORT_FROM_ACCOUNT_LIST:
            draft.importFromAccount.setList = action.setList
            return draft

        case types.CC_LIBRARY_SET_IMPORT_FROM_ACCOUNT_IDS:
            draft.importFromAccount.setIds = action.setIds
            return draft

        case types.CC_LIBRARY_SET_IMPORT_FROM_ACCOUNT_SORT:
            draft.importFromAccount.sortColumn = action.sortColumn
            draft.importFromAccount.sortOrder = action.sortOrder
            return draft

        case types.CC_LIBRARY_SET_IMPORT_FROM_ACCOUNT_FILTERS:
            draft.importFromAccount.filters = action.filters
            return draft


        case types.CC_LIBRARY_SET_IMPORT_ID:
            draft.importSetId = action.setId
            return draft

        case types.CC_LIBRARY_SET_RELOAD_IMPORTED:
            draft.reloadImported = action.value
            return draft

        default:
            return draft
    }
})
export default ccLibrarySetReducer
